import React, { useContext } from "react";
import { SearchContext } from "@context/SearchContext";
import "./style.scss";

const ExperienceItems = ({ handleExperienceClick, selectedExperiences = [], selectedShortNames = [] }) => {
    const { availableClasses } = useContext(SearchContext);
    if (availableClasses.length === 0) {
        return null;
    }

    const handleCheckboxChange = (type) => {
        const updatedSelections = selectedExperiences.includes(type)
            ? selectedExperiences.filter((t) => t !== type)
            : [...selectedExperiences, type];
        handleExperienceClick(updatedSelections);
    };

    const handleKeyDown = (event, type) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            handleCheckboxChange(type);
        }
    };

    return (
        <div className="experience">
            <h2 id="experience-filter-title" className="experience__title">Experience Filter</h2>
            <div className="experience__wrapper" role="group" aria-labelledby="experience-filter-title">
                {availableClasses.map((exp, index) => {
                    const value = exp?.short_name || `unknown-${index}`;
                    const name = exp?.long_name || "Unnamed";
                    const colorClass = exp?.short_name || value.toUpperCase() || "default";
                    const isChecked = selectedShortNames?.includes(value);
                    
                    return (
                        <label
                            key={`exp-${value}-${index}`}
                            className={`experience__item experience__item--${colorClass} ${isChecked ? "experience__item--selected" : ""}`}
                            tabIndex={0}
                            role="checkbox"
                            aria-checked={isChecked}
                            onKeyDown={(e) => handleKeyDown(e, value)}
                        >
                            <div className="experience__content">
                                <span className="experience__label">
                                    {name}
                                </span>
                                <span className="experience__description">{exp?.name_list}</span>
                            </div>
                            <input
                                type="checkbox"
                                name="experience"
                                value={value}
                                checked={isChecked}
                                onChange={() => handleCheckboxChange(exp?.id)}
                                className="experience__checkbox"
                            />
                            <span
                                className={`experience__custom-checkbox ${isChecked ? "experience__custom-checkbox--checked" : ""}`}
                                tabIndex="-1"
                            />
                        </label>
                    );
                })}
            </div>
        </div>
    );
};

export default ExperienceItems;
